import { useEditor, Element } from '@craftjs/core';
import {
  Type,
  Heading,
  Image,
  Video,
  Quote,
  MousePointer,
  Minus,
  MoveVertical,
  Code2,
  Globe,
  Columns,
} from 'lucide-react';
import { TextBlock } from './TextBlock';
import { HeadingBlock } from './HeadingBlock';
import { ImageBlock } from './ImageBlock';
import { VideoBlock } from './VideoBlock';
import { QuoteBlock } from './QuoteBlock';
import { CTABlock } from './CTABlock';
import { DividerBlock } from './DividerBlock';
import { SpacerBlock } from './SpacerBlock';
import { CodeBlock } from './CodeBlock';
import { EmbedBlock } from './EmbedBlock';
import { ColumnsBlock } from './ColumnsBlock';

type BlockDefinition = {
  label: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: any;
  icon: React.ElementType;
};

const blocks: BlockDefinition[] = [
  { label: 'Texto', component: TextBlock, icon: Type },
  { label: 'Título', component: HeadingBlock, icon: Heading },
  { label: 'Imagem', component: ImageBlock, icon: Image },
  { label: 'Vídeo', component: VideoBlock, icon: Video },
  { label: 'Citação', component: QuoteBlock, icon: Quote },
  { label: 'CTA', component: CTABlock, icon: MousePointer },
  { label: 'Divisor', component: DividerBlock, icon: Minus },
  { label: 'Espaço', component: SpacerBlock, icon: MoveVertical },
  { label: 'Código', component: CodeBlock, icon: Code2 },
  { label: 'Embed', component: EmbedBlock, icon: Globe },
  { label: 'Colunas', component: ColumnsBlock, icon: Columns },
];

export function BlockToolbar() {
  const { connectors } = useEditor();

  return (
    <div className="space-y-2 p-3">
      <h3 className="text-sm font-semibold text-muted-foreground mb-3">Blocos</h3>
      <div className="grid grid-cols-2 gap-2">
        {blocks.map(({ label, component: Comp, icon: Icon }) => (
          <div
            key={label}
            ref={(ref) => {
              if (ref) {
                connectors.create(ref, <Element is={Comp} canvas />);
              }
            }}
            className="flex flex-col items-center gap-1 p-3 border rounded-lg cursor-grab hover:bg-muted transition-colors text-center select-none"
          >
            <Icon className="h-5 w-5 text-muted-foreground" />
            <span className="text-xs">{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
